import { useSelector } from 'react-redux';
import { _activePermissions } from 'store/sagas/Selectors';

export const usePermissions = () => {
    const activePermissions = useSelector(_activePermissions);

    const hasPermission = permission => {
        if (!activePermissions) return false;
        return activePermissions.includes(permission);
    };

    const hasAnyPermission = (permissions = []) => {
        if (!activePermissions) return false;
        return permissions.some(permission => activePermissions.includes(permission));
    };

    const hasAllPermissions = (permissions = []) => {
        if (!activePermissions) return false;
        return permissions.every(permission => activePermissions.includes(permission));
    };

    return {
        hasPermission,
        hasAnyPermission,
        hasAllPermissions,
        activePermissions
    };
};
